
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FormItemProps } from ".";
import { loading, create } from "store/form";
import { AppMessage } from "components";

interface ApiFormCreateInputProps extends Omit<FormItemProps, "id"> {
}

type ApiFormCreateOutputProps = OutputBaseProps<{ item: FormItemProps; }, ApiFormCreateInputProps>

export const apiFormCreate = async (data: ApiFormCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiFormCreateOutputProps>("/api/form/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};